/**
 * in-memory store for category modal state.
 */

let modalState = null;

/**
 * @param {Object} state
 * @param {Array} state.navigationHistory
 * @param {Array} state.currentSubcategories
 * @param {string} state.mainCategory
 */
export const saveModalState = (state) => {
  modalState = {
    navigationHistory: state.navigationHistory || [],
    currentSubcategories: state.currentSubcategories || [],
    mainCategory: state.mainCategory || null,
    savedAt: Date.now(),
  };
};

/**
 * @returns {Object|null}
 */
export const getModalState = () => {
  if (!modalState) {
    return null;
  }
  
  // Expire after 5 minutes
  if (Date.now() - modalState.savedAt > 5 * 60 * 1000) {
    modalState = null;
    return null;
  }
  
  return modalState;
};

export const clearModalState = () => {
  modalState = null;
};

/**
 * Check if there's a valid modal state to restore
 * @returns {boolean}
 */
export const hasModalStateToRestore = () => {
  return modalState !== null && (Date.now() - modalState.savedAt < 5 * 60 * 1000);
};
